<template>
  <div class="createdActivity">
    <div class="createdActivity-form">
      <div class="headline">
        <p>
          <span style="color: red">*</span>
          活动标题
        </p>
        <input type="text" v-model="texts.headline" />
      </div>

      <div class="address">
        <p>
          <span style="color: red">*</span>
          活动地址
        </p>
        <input type="text" v-model="texts.address" />
      </div>

      <!-- <div class="startTime">
        <p>
          <span style="color: red">*</span>
          选择申报所在党支部
        </p>
        <div class="selectParty">
          <div>
            <el-radio :disabled="idDisabled" v-model="texts.remark" label="0"
              >报到党支部</el-radio
            >
          </div>
          <div>
            <el-radio :disabled="idDisabled" v-model="texts.remark" label="1"
              >所在党支部</el-radio
            >
          </div>
        </div>
      </div> -->

      <div class="startTime">
        <p>
          <span style="color: red">*</span>
          活动开始时间
        </p>
        <div class="optionsbox">
          <el-date-picker
            v-model="texts.startTime"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="startTime">
        <p>
          <span style="color: red">*</span>
          活动结束时间
        </p>
        <div class="optionsbox">
          <el-date-picker
            v-model="texts.endTime"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="text">
        <p>
          <span style="color: red">*</span>
          活动描述
        </p>
        <div class="options">
          <Uedior />
        </div>
      </div>
    </div>
    <div class="submit" @click="submit">确认提交</div>
    <!-- 提交成功 -->
    <el-dialog :visible.sync="submitVisible" class="dialog">
      <div class="dialog-imgbox">
        <img src="@/assets/partyreports/tc-icon.png" alt="" />
        <div class="dialog-title">
          <p>个人活动申报提交成功！</p>
          <p>等待管理员审核</p>
        </div>
        <div>
          <div class="button" @click="back">返回上一级</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uedior from "@/views/component/Uedior";
export default {
  data() {
    return {
      submitVisible: false,
      idDisabled: false,
      texts: {
        headline: "",
        address: "",
        startTime: "",
        endTime: "",
        msg: ""
      },
      c2userid: ''
    };
  },
  created() {
    this.c2userid = sessionStorage.getItem('c2userid')
  },
  methods: {
    submit() {
      for (let key in this.texts) {
        if (this.texts[key] == "") {
          this.$message({
            message: "请填写完整",
            type: "error",
            offset: 300,
          });
          return false;
        }
      }
      if (this.texts.startTime >= this.texts.endTime) {
        this.$message({
          message: "活动开始时间不能大于或等于活动结束时间！",
          type: "error",
          offset: 300,
        });
        return false;
      }
      this.texts.startTime = this.$fun.time(this.texts.startTime);
      this.texts.endTime = this.$fun.time(this.texts.endTime);

      let params = {
        userid: parseInt(this.c2userid),
        headline: this.texts.headline,
        address: this.texts.address,
        startActivityTime: this.texts.startTime,
        endActivityTime: this.texts.endTime,
        memo: this.texts.msg,
      };
      this.axios.post("/api/MyActivity/AddActivity", params).then((res) => {
        for (let key in this.texts) {
          this.texts[key] = "";
        }
        this.submitVisible = true;
      });
    },
    back() {
      window.history.go(-1);
    },
  },
  components: {
    Uedior,
  },
  mounted(){
    if(sessionStorage.getItem("status") == 0){
      this.texts.remark = '0';
      this.idDisabled = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.createdActivity {
  &-form {
    input {
      width: 100%;
      border-radius: 0.1rem;
      padding: 0.2rem;
      border: none;
      background: #e9e9e9;
      margin-top: 0.2rem;
      margin-bottom: 0.4rem;
      font-size: 0.32rem;
    }
    p {
      font-size: 0.26rem;
      color: #666666;
    }
    .startTime {
      /deep/.el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
    }
    .text {
      margin-bottom: 0.4rem;
    }
    .optionsbox {
      margin: 0.1rem 0 0.4rem;
    }
    .selectParty {
      div {
        margin-right: 0.5rem;
      }
      height: 0.4rem;
      align-items: center;
      display: flex;
      margin-bottom: 0.4rem;
      margin-top: 0.1rem;
    }
    .options {
      /deep/.el-input__inner {
        background-color: #e9e9e9;
        border: none;
      }
      /deep/.el-select {
        width: 100%;
      }
      /deep/.el-textarea__inner {
        border: none;
        background-color: #e9e9e9;
        height: 4.15rem;
        color: black;
      }
      margin-top: 0.1rem;
    }

    .uploadBox {
      margin: 0.38rem 0 0.55rem;
    }

    font-size: 0.32rem;
    margin-top: 0.3rem;
  }
  .submit {
    width: 4.6rem;
    height: 0.76rem;
    background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
    box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
    border-radius: 0.08rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: #f6f5f8;
    line-height: 0.76rem;
    margin: 0 auto 0;
    text-align: center;
  }
  .dialog {
    &-imgbox {
      img {
        width: 1.74rem;
        height: 1.74rem;
        border-radius: 50%;
      }
    }
    &-title {
      > p:nth-of-type(1) {
        font-size: 0.26rem;
        font-weight: 500;
        color: #666666;
        margin-bottom: 0.1rem;
      }
      > p:nth-of-type(2) {
        font-size: 0.3rem;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.3rem;
      }
    }
    .button {
      width: 2.85rem;
      height: 0.76rem;
      background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
      border-radius: 0.08rem;
      text-align: center;
      font-size: 0.3rem;
      font-weight: 500;
      color: #f6f5f8;
      line-height: 0.76rem;
      margin: 0 auto 0;
    }
    // padding-bottom: 0.71rem;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 2.2rem;
    height: 2.2rem;
    margin: 0 0.13rem 0.08rem 0;
  }
  /deep/.el-upload--picture-card {
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
  }

  /deep/.el-input__inner {
    background-color: #e9e9e9;
    border: none;
  }
  /deep/.el-dialog {
    width: 70%;
    text-align: center;
  }
  padding: 1rem 0.25rem 1rem;
}
</style>
<style lang="scss">
.el-time-panel {
  right: 0;
  left: auto;
}
</style> 
